// extracted by mini-css-extract-plugin
export var bgGradientPpc = "index-module--bg-gradient-ppc--8d06a";
export var bulletsHeroPpc = "index-module--bullets-hero-ppc--9a311";
export var heading = "index-module--heading--508b7";
export var headingContainer = "index-module--heading-container--06b25";
export var highlight = "index-module--highlight--da33e";
export var highlightLine = "index-module--highlight-line--7500a";
export var image1 = "index-module--image-1--db5c6";
export var image2 = "index-module--image-2--8c8a0";
export var imageContainer = "index-module--image-container--4cacf";